import React from 'react';
import { useFulfillmentDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/store/fulfillmentDashboard.store';
import { useChartColors } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import {
  HorizontalBarChart,
  HorizontalBarItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/HorizontalBarChart';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/OverviewDashboard.styled';
import { getFulfillmentBarColor } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/FulfillmentDashboard.constants';
import { formatDashboardNumber } from 'pages/ReportsPage/components/AnalyticsDashboards/formatDashboardNumber';

export const FulfillmentByTimeframeChart: React.FC = () => {
  const data = useFulfillmentDashboardStore((s) => s.fulfillmentByTimeframe);
  const palette = useChartColors();

  if (!data || data.length === 0) {
    return <EmptyStateContainer>No data available</EmptyStateContainer>;
  }

  const items: HorizontalBarItem[] = data.map((d) => {
    const color = getFulfillmentBarColor(
      d.fulfillmentPercentage,
      palette.chartColors,
      palette.threshold,
    );
    const percentage = formatDashboardNumber(d.fulfillmentPercentage);
    return {
      label: d.timeframe,
      value: d.fulfillmentPercentage,
      valueLabel: `${percentage}% (${d.totalShifts} shifts)`,
      ariaLabel: `${d.timeframe}: ${percentage}% (${d.totalShifts} shifts)`,
      tooltipHtml: `<strong>${d.timeframe}</strong><br/>Fulfillment: ${percentage}%<br/>Shifts: ${d.totalShifts}`,
      barColor: color,
      valueLabelColor: color,
    };
  });

  return (
    <HorizontalBarChart
      items={items}
      maxValue={100}
      ariaLabel="Fulfillment percentage by timeframe"
    />
  );
};
